<template>
  <!--
    Instagram /embed (без /captioned = caption hidden).
    iframe src выставляется только у viewport — иначе лента грузит все embed сразу.
  -->
  <div ref="root" class="cm-ig-embed">
    <div class="cm-embed is-ig" :class="{ 'is-reel': isReel }">
      <iframe
        v-if="active && embedSrc"
        :src="embedSrc"
        allow="autoplay; encrypted-media; fullscreen; picture-in-picture;"
        frameborder="0"
        allowfullscreen
        scrolling="no"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "Cm-ig-embed",
  props: {
    /** https://www.instagram.com/reel|p|tv/CODE/ or .../embed */
    url: { type: String, required: true },
  },
  data() {
    return { active: false };
  },
  computed: {
    embedSrc() {
      const raw = (this.url || "").trim();
      if (!raw) return "";
      // нормализуем к .../reel|p|tv/CODE/embed (без captioned)
      let path = raw.split("?")[0].replace(/\/embed\/?(captioned)?\/?$/i, "");
      path = path.replace(/\/?$/, "/");
      const match = path.match(/instagram\.com\/(reel|p|tv)\/([^/]+)/i);
      if (!match) return "";
      return `https://www.instagram.com/${match[1].toLowerCase()}/${match[2]}/embed`;
    },
    isReel() {
      return /\/reel\//i.test(this.embedSrc);
    },
  },
  watch: {
    url() {
      this.active = false;
      this.$nextTick(this.observe);
    },
  },
  mounted() {
    this.observe();
  },
  beforeDestroy() {
    this.unobserve();
  },
  methods: {
    observe() {
      this.unobserve();
      if (!this.embedSrc) return;
      if (typeof IntersectionObserver === "undefined") {
        this.active = true;
        return;
      }
      this._io = new IntersectionObserver(
        (entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          this.active = true;
          this.unobserve();
        },
        { root: null, rootMargin: "250px 0px", threshold: 0.01 },
      );
      if (this.$refs.root) this._io.observe(this.$refs.root);
    },
    unobserve() {
      if (this._io) {
        this._io.disconnect();
        this._io = null;
      }
    },
  },
};
</script>

<style scoped>
.cm-ig-embed {
  margin: 8px auto;
  max-width: 540px;
}
.cm-embed {
  position: relative;
  width: 100%;
  margin-bottom: 8px;
  border-radius: 8px;
  overflow: hidden;
  background: #f4f4f4;
}
.cm-embed.is-ig {
  height: min(70vh, 560px);
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
}
.cm-embed.is-ig.is-reel {
  height: min(85vh, 500px);
  max-width: 420px;
}
.cm-embed iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
